/**
 * What the QR label carries and how a scan is read back (contract sprint 3 §12).
 * The QR encodes a URL with the system id — a phone camera opens the karton, the
 * in-app scanner extracts the code. Old labels carried the bare tag; `scannedAssetCode`
 * returns any bare text unchanged so those still resolve (the server tries id, then tag).
 */

const LANDING_PATH = "/a/";

/** The QR content for a label: `https://host/a/A-00000053`. */
export function assetQrUrl(inventoryNo: string, origin: string = window.location.origin): string {
  return `${origin}${LANDING_PATH}${encodeURIComponent(inventoryNo)}`;
}

/** The code inside a scanned / typed text: last path segment of a label URL, else the trimmed text. */
export function scannedAssetCode(text: string): string {
  const raw = text.trim();
  if (!/^https?:\/\//i.test(raw)) return raw;
  try {
    const url = new URL(raw);
    const path = url.pathname;
    const idx = path.indexOf(LANDING_PATH);
    const segment = idx >= 0 ? path.slice(idx + LANDING_PATH.length) : path.slice(path.lastIndexOf("/") + 1);
    return decodeURIComponent(segment.replace(/\/+$/, "")).trim() || raw;
  } catch {
    return raw;
  }
}
